
export const CatalogNoItems = () => {
    return (
        <div className="catalog__noitems">
            <img className="catalog__noitems-img" src="./img/no_items.svg" alt="" />

            <div className="catalog__noitems-text">
                <p>Sorry, no&nbsp;items were found for your search.</p>
                <p>Please try again.</p>
            </div>

        </div>)
};

export default CatalogNoItems;